export const intent = {
  NONE: "none",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  DANGER: "danger",
  CAUTION: "caution",
};
